import React , {Component} from  'react'
import { connect } from 'react-redux'
import { fetchWarehouses, addWarehouse } from '../../redux/warehouse/actions/actionCreators'
import {Select , Form , Input , Button , Table , Modal , Row , Col , Spin , message} from 'antd'
import Axios from 'axios'
import keys from '../../keys'


const {confirm} = Modal

class ViewWarehouse extends Component{
    
    state = {
        modal_visible : false
    }
    


    componentDidMount () {
        console.log(this.props)
        this.props.fetchWarehouses()
    }
   

    setWarehouseOptions = (data) =>{
        this.setState(
            {
                warehouses: data
            },() => console.log(this.state)
        )
    }

    formatTableData = () => {
        const data = this.props.warehouses
        return data.map(
            (warehouse, index) => {
                return {
                    key:index,
                    title :  warehouse.title ,
                    entity : warehouse.entity,
                    id: warehouse.id,
                    delete_id : warehouse.id
                }
            }
        )
    }

    showDeleteConfirm = (warehouse_id , callback) =>  {
        confirm({
          title: 'Are you sure delete this warehouse?',
          content: 'You can\'t delete this warehouse if you have products in this!',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk() {
            Axios.delete(
                `${keys.server}/warehouse/warehouses/${warehouse_id}`  
            )
            .then(
                result => {
                    message.success("Warehouse Deleted Successfully")
                    callback()
                }
            )
            .catch(
                err => {
                    console.log(err);
                    message.error("Oops! Something went wrong with deleting this warehouse")
                }
            )
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      }  






    columns = [
        {
            key: "no",
            dataIndex: "title",
            title : "Warehouse Name"
        }
        ,

        {
            key: "entity",
            dataIndex: "entity",
            title : "Entity"
        }
        ,
        {
            key: "delete",
            dataIndex: "delete_id",
            title : "",
            render: (id) => <Button type="danger" onClick={() => this.showDeleteConfirm(id , this.props.fetchWarehouses)}  >Delete</Button>
        }

    ]


   

    handleOk = () => {

    
        this.props.addWarehouse(
            {
                title : this.state.warehouse_title,
                entity : this.state.entity
            }
        )
        this.setState({
            modal_visible:false,
            warehouse_title : null,
            entity:null

        })
    }


    handleCancel = () => {
        this.setState({
            modal_visible:false,
            warehouse_title : null,
            entity:null
        })
    }

 


    render(){

      return (

       <Spin spinning={this.props.loading} > 
        <Row>
            <Col offset={20} span={4}> <Button htmlType="button" type= "primary" onClick={(e)=> this.setState({modal_visible:true})}> Add New Warehouse</Button>  </Col>
        </Row>     
        <Table dataSource = {this.formatTableData()}  columns= {this.columns}/> 
        <Form onSubmit={this.handleSubmit}>
        <Modal
            title="New Warehouse"
            visible={this.state.modal_visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}

            footer={[
                <Button key="back" onClick={this.handleCancel}>
                  Cancel
                </Button>,
                <Button key="submit" type="primary" htmlType="submit" loading={this.props.loading} onClick={this.handleOk}>
                  Add Warehouse
                </Button>,
              ]}
            >
                <Row gutter={20}>
                    <Col span={12}>
                        <Form.Item label="Warehouse name">
                            <Input required onChange={(e) => this.setState({warehouse_title:e.target.value})} value={this.state.warehouse_title}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Entity">
                            <Select style={{width:200}} value = {this.state.entity} onChange={v => this.setState({entity:v},() => console.log(this.state))}>
                                <Select.Option value="ROYALMARKETING"> Royal Marketing </Select.Option>
                                <Select.Option value="SEGA"> Sega </Select.Option>
                                <Select.Option value="CHITFUND"> Chit Fund </Select.Option>
                            </Select>
                        </Form.Item>  
                    </Col>
                </Row>
            
                    
            </Modal>   
            </Form>
      
      </Spin>   
      
      )

    }

}

const mapStateToProps = state => {
    return {
        warehouses : state.warehouse.warehouses,
        loading : state.warehouse.loading
    }
}

const mapDispatchToProps = dispatch =>{
    return {
        fetchWarehouses : () => dispatch(fetchWarehouses()),
        addWarehouse : (data) => dispatch(addWarehouse(data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ViewWarehouse)